/**
 * This file is responsible for handling the service calls for the account
 */
import { callAPI, GATEWAY_PROXY, METHODS } from "utils/apiUtils";

export function AuthenticateDomainService(
	options = { domain: "", protocol: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + `/domains/${options.domain}/${options.protocol}`,
			method: METHODS.get,
		},
		successCallback,
		failureCallback
	);
}

export function ListDkimService(
	options,
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/brands/default/dkim",
			method: METHODS.get
		},
		successCallback,
		failureCallback
	);
}

export function CreateDkimService(
	options,
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/brands/default/dkim",
			method: METHODS.post,
			body: options
		},
		successCallback,
		failureCallback
	);
}

export function showDomainService(
	options = {},
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/brands/default/domains/default",
			method: METHODS.get,
		},
		successCallback,
		failureCallback
	);
}

export function updateDomainService(
	options = { domains : {}},
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/brands/default/domains/default",
			method: METHODS.patch,
			body : options,
		},
		successCallback,
		failureCallback
	);
}

export function validateDomainService(
	options = { },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/brands/default/domains/default/validate",
			method: METHODS.get
		},
		successCallback,
		failureCallback
	);
}


export function isPublicEmailProviderService(
	options = { domain: "" },
	successCallback = () => {},
	failureCallback = () => {}
){
	callAPI(
		{
			url: GATEWAY_PROXY + "/domains/publicEmailProviders/" + options.domain,
			method : METHODS.get
		},
		successCallback,
		failureCallback
	);
}

//This route test all business logic in the backend, so if the response is the same has the sender email, then dmarc passes
//otherwise you get the fallback email
export function getFallbackSenderEmailService(
	options = { email: "" },
	successCallback = () => {},
	failureCallback = () => {}
){
	callAPI(
		{
			url: GATEWAY_PROXY + "/domains/fallbackEmail",
			body : {
				email : options.email
			},
			method : METHODS.post
		},
		successCallback,
		failureCallback
	);
}


export function isDomainValidService(
	options = { domain: "" },
	successCallback = () => {},
	failureCallback = () => {}
){
	callAPI(
		{
			url: GATEWAY_PROXY + "/domains/"+options.domain+"/isVerified",
			method : METHODS.get
		},
		successCallback,
		failureCallback
	);
}

export function domainHasValidCertificateService(
	options = { domain : "" },
	successCallback = () => {},
	failureCallback = () => {}
){
	callAPI(
		{
			url: GATEWAY_PROXY + "/domains/testScheme",
			method : METHODS.post,
			body : {
				url : options.domain
			}
		},
		successCallback,
		failureCallback
	);
}

export function getPartnerDomainsInfoService(
	options = {},
	successCallback = () => {},
	failureCallback = () => {}
){
	callAPI(
		{
			url: GATEWAY_PROXY + "/domains/getPartnerDomainBrandingInformation",
			method : METHODS.get
		},
		successCallback,
		failureCallback
	);
}

export function verifyTrackingCnamesService(
	options = {tracking : "", bounce : ""},
	successCallback = () => {},
	failureCallback = () => {}
){
	callAPI(
		{
			url: GATEWAY_PROXY + "/domains/verifyTrackingCnames",
			method : METHODS.post,
			body : {
				"tracking": options.tracking,
				"bounce": options.bounce
			 }
		},
		successCallback,
		failureCallback
	);
}

